import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import Swal from 'sweetalert2';
import {
  Card,
  CardHeader,
  Container,
  Row,
  Button,
  Input,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Modal,
  CardBody,
  Form,
  Col,
  Badge,
  ModalBody,
  Table,
  ModalHeader,
} from 'reactstrap';
import Header from 'components/Headers/Header.js';
import {
  FaEdit,
  FaPlusCircle,
  FaTimesCircle,
  FaCheckCircle,
  FaTable,
  FaEyeSlash,
  FaEye,
  FaList,
  FaSearch,
  FaHistory,
  FaRegListAlt,
  FaMoneyBill,
} from 'react-icons/fa';
import api from 'services/api';
import { Checkbox, FormControlLabel, Tooltip } from '@material-ui/core';
import { iTabelaGenerica } from 'models/TabelaGenerica';
import { Link } from 'react-router-dom';
import { AutoSizer, Column, List, Table as Tbl } from 'react-virtualized';
import './style.css';
import ModalLog from 'components/ModalLog';
import formatCurrency from 'utils/formatCurrency';
import { BuscarRegras } from './styles';

interface editTabelaGenerica extends iTabelaGenerica {
  labelValido: boolean;
}

export interface iMaterial {
  id: number;
  diteCodigo: string;
  fabrCodigo?: string;
  fabrEmprCodigo?: string;
  diteDgpeCodigo?: string;
  descricao?: string;
  dataUltimaIntegracao?: any;
  createdAt?: any;
  updatedAt?: any;
  isAtivo: boolean;
  codigoSap: string | null;
  integracaoId: number | null;
  descricaoFabrSge: string | null;
  fabrNome: string | null;
  fabrSap: string | null;
}

interface iMaterialPrecificacao {
  id: number;
  materialId: number;
  atividade: string;
  empresa: string;
  valor: number;
  updatedAt?: any;
  integracaoId: number | null;
  custo: number | null;
  custoImp: number | null;
  canalDistribuicao: string | null;
  centroLucro: string | null;
  organizacaoVenda: string | null;
  setorAtividade: string | null;
}

interface iMaterialComposicao {
  id: number;
  material: iMaterial;
  materialId: number;
  quantidade: string;
  updatedAt?: any;
  integracaoId: number | null;
}

const Materiais: React.FC = () => {
  const [listaMaterial, setListaMaterial] = useState([] as iMaterial[]);
  const [listaMaterialFiltrada, setListaMaterialFiltrada] = useState(
    [] as iMaterial[],
  );
  const [listaPrecificacao, setListaPrecificacao] = useState(
    [] as iMaterialPrecificacao[],
  );
  const [listaComposicao, setListaComposicao] = useState(
    [] as iMaterialComposicao[],
  );
  const [modalPrecificacaoVisivel, setModalPrecificacaoVisivel] =
    useState(false);
  const [modalComposicaoVisivel, setModalComposicaoVisivel] = useState(false);
  const [loadingDadosPrecificacao, setLoadingDadosPrecificacao] =
    useState(false);
  const [loadingDadosComposicao, setLoadingDadosComposicao] = useState(false);
  const [modalMaterial, setModalMaterial] = useState<iMaterial>(
    {} as iMaterial,
  );

  const [modalLogVisivel, setModalLogVisivel] = useState(false);
  const [mostrarDesativados, setMostrarDesativados] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalProp, setModalProp] = useState('');
  const [campoBusca, setCampoBusca] = useState('');

  async function carregarDados() {
    setLoading(true);
    const response = await api.get('/material');

    const lista = response.data as iMaterial[];

    setListaMaterial(lista);
    setLoading(false);
  }

  useEffect(() => {
    carregarDados();
  }, []);

  async function filtrar() {
    let lista = listaMaterial;

    if (campoBusca) {
      lista = listaMaterial.filter(item => {
        return (
          String(item.codigoSap)
            .toUpperCase()
            .includes(campoBusca.toUpperCase()) ||
          String(item.descricao)
            .toUpperCase()
            .includes(campoBusca.toUpperCase()) ||
          String(item.descricaoFabrSge)
            .toUpperCase()
            .includes(campoBusca.toUpperCase()) ||
          String(item.diteCodigo)
            .toUpperCase()
            .includes(campoBusca.toUpperCase()) ||
          String(item.id).toUpperCase().includes(campoBusca.toUpperCase())
        );
      });
    }

    const novaLista = lista.filter(item =>
      mostrarDesativados ? true : item.isAtivo === true,
    );

    setListaMaterialFiltrada(novaLista);
  }

  useEffect(() => {
    if (listaMaterialFiltrada) {
      filtrar();
    }
  }, [listaMaterial, mostrarDesativados, campoBusca]);

  async function mostrarModalLog(material: iMaterial) {
    setModalProp(`${material.id}`);
    setModalLogVisivel(true);
  }

  async function mostrarLogPrecificacao(material: iMaterial) {
    setLoadingDadosPrecificacao(true);
    setListaPrecificacao([]);
    setModalMaterial({} as iMaterial);

    const response = await api.get(`/material/${material.id}/precificacao`);

    const lista = response.data as iMaterialPrecificacao[];

    setModalMaterial(material);
    setListaPrecificacao(lista);
    setModalPrecificacaoVisivel(true);
    setLoadingDadosPrecificacao(false);
  }

  async function mostrarLogComposicao(material: iMaterial) {
    setLoadingDadosComposicao(true);
    setListaComposicao([]);
    setModalMaterial({} as iMaterial);

    const response = await api.get(`/material/${material.id}/composicao`);

    const lista = response.data as iMaterialComposicao[];

    setModalMaterial(material);
    setListaComposicao(lista);
    setModalComposicaoVisivel(true);
    setLoadingDadosComposicao(false);
  }

  async function filtroTabela(
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) {
    const search = event.target.value;

    setCampoBusca(search);
  }

  return (
    <>
      <Header showCards={false} />
      {/* Page content */}

      <ModalLog
        nomeChave="material_id"
        valorChave={modalProp}
        titulo="Logs"
        modalState={modalLogVisivel}
        toggle={() => setModalLogVisivel(false)}
      />

      <Modal
        className="modal-dialog-centered"
        size="xl"
        style={{ maxWidth: '80vw', width: '100%' }}
        isOpen={modalPrecificacaoVisivel}
        toggle={() => setModalPrecificacaoVisivel(false)}
      >
        <ModalBody>
          <h3 className="mb-0">
            Detalhes de Precificação do material {modalMaterial.diteCodigo}
          </h3>
          {loadingDadosPrecificacao && (
            <>Buscando dados da precificação do material</>
          )}
          {!loadingDadosPrecificacao && (
            <>
              <Table
                className="align-items-center table-flush table-striped mt-1"
                responsive
              >
                <thead>
                  <tr>
                    <th>Canal Distrib.</th>
                    <th>Centro Lucro</th>
                    <th>Org. Venda</th>
                    <th>Setor Ativ.</th>
                    <th>Valor</th>
                    <th>Custo</th>
                    <th>Custo Imp</th>
                    <th>Integração</th>
                  </tr>
                </thead>
                <tbody>
                  {listaPrecificacao.map(
                    (registro: iMaterialPrecificacao, index: number) => {
                      return (
                        <tr key={`id_${index}`}>
                          <td>{registro.canalDistribuicao} </td>
                          <td>{registro.centroLucro} </td>
                          <td>{registro.organizacaoVenda} </td>
                          <td>{registro.setorAtividade} </td>
                          <td>{formatCurrency(registro.valor ?? 0)} </td>
                          <td>{formatCurrency(registro.custo ?? 0)} </td>
                          <td>{formatCurrency(registro.custoImp ?? 0)} </td>
                          <td>
                            #{registro.integracaoId ?? null}
                            {' em '}
                            {new Intl.DateTimeFormat('pt-BR', {
                              dateStyle: 'short',
                              timeStyle: 'medium',
                            }).format(new Date(registro.updatedAt))}
                          </td>
                        </tr>
                      );
                    },
                  )}
                </tbody>
              </Table>
            </>
          )}
        </ModalBody>
      </Modal>

      <Modal
        className="modal-dialog-centered"
        size="xl"
        isOpen={modalComposicaoVisivel}
        style={{ maxWidth: '80vw', width: '100%' }}
        toggle={() => setModalComposicaoVisivel(false)}
      >
        <ModalBody>
          <h3 className="mb-0">
            Detalhes da Composição do material {modalMaterial.diteCodigo}
          </h3>
          {loadingDadosComposicao && (
            <>Buscando dados da composição do material</>
          )}
          {!loadingDadosComposicao && (
            <>
              <Table
                className="align-items-center table-flush table-striped mt-1"
                responsive
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>SAP</th>
                    <th>DomSGE</th>
                    <th>Empresa</th>
                    <th>Descrição</th>
                    <th>Quantidade</th>
                    <th>Integração</th>
                  </tr>
                </thead>
                <tbody>
                  {listaComposicao.map(
                    (registro: iMaterialComposicao, index: number) => {
                      return (
                        <tr key={`id_${index}`}>
                          <td>{registro.material.id} </td>
                          <td>{registro.material.codigoSap ?? ''} </td>
                          <td>{registro.material.diteCodigo} </td>
                          <td>{registro.material.fabrEmprCodigo ?? ''} </td>
                          <td>{registro.material.descricao}</td>
                          <td>{registro.quantidade} </td>
                          <td>
                            #{registro.integracaoId ?? null}
                            {' em '}
                            {new Intl.DateTimeFormat('pt-BR', {
                              dateStyle: 'short',
                              timeStyle: 'medium',
                            }).format(new Date(registro.updatedAt))}
                          </td>
                        </tr>
                      );
                    },
                  )}
                </tbody>
              </Table>
            </>
          )}
        </ModalBody>
      </Modal>

      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row>
                  <Col sm="6">
                    <h3 className="mb-0">Lista de Materiais</h3>
                  </Col>
                  <Col sm="6" hidden>
                    <FormControlLabel
                      className="float-right"
                      control={
                        <Checkbox
                          checked={mostrarDesativados}
                          onChange={event =>
                            setMostrarDesativados(event.target.checked)
                          }
                          color="primary"
                        />
                      }
                      label="Mostrar desativados"
                    />
                  </Col>
                </Row>
              </CardHeader>

              <Row>
                <Col sm="8">
                  <div className="ml-4">
                    <i>
                      Exibindo {listaMaterialFiltrada?.length ?? 0} de{' '}
                      {listaMaterial
                        ? listaMaterial.filter(item =>
                            mostrarDesativados ? true : item.isAtivo === true,
                          )?.length ?? 0
                        : 0}{' '}
                      registros
                    </i>
                  </div>
                </Col>
                <Col sm="4">
                  <BuscarRegras
                    className="float-right mr-2"
                    id="outlined-basic"
                    label="Buscar"
                    variant="outlined"
                    size="small"
                    type="text"
                    onChange={event => {
                      filtroTabela(event);
                    }}
                  />
                </Col>
              </Row>

              {listaMaterialFiltrada && listaMaterialFiltrada.length > 0 && (
                <div className="mt-4">
                  <div style={{ height: '600px', width: '100%' }}>
                    <AutoSizer>
                      {({ height, width }) => (
                        <Tbl
                          gridStyle={{ outline: 'none' }}
                          width={width}
                          height={height}
                          headerHeight={30}
                          rowHeight={70}
                          rowCount={listaMaterialFiltrada.length}
                          rowGetter={({ index }: { index: number }) =>
                            listaMaterialFiltrada[index]
                          }
                        >
                          <Column width={100} label="#" dataKey="id" />
                          <Column width={100} label="SAP" dataKey="codigoSap" />
                          <Column
                            width={200}
                            label="DomSGE"
                            dataKey="diteCodigo"
                          />
                          <Column
                            label="Descrição"
                            dataKey="descricao"
                            width={400}
                            flexGrow={1}
                            cellRenderer={({ cellData }) => (
                              <div
                                style={{
                                  whiteSpace: 'normal',
                                  wordBreak: 'break-word',
                                  overflowWrap: 'break-word',
                                  lineHeight: '1.4',
                                  display: 'block',
                                }}
                              >
                                {cellData}
                              </div>
                            )}
                          />

                          <Column
                            width={300}
                            label="Fabricante"
                            dataKey="fabrCodigo"
                            cellRenderer={({ rowData }) => (
                              <div
                                style={{
                                  whiteSpace: 'normal',
                                  wordBreak: 'break-word',
                                  overflowWrap: 'break-word',
                                  lineHeight: '1.4',
                                  display: 'block',
                                }}
                              >
                                {rowData?.fabrSap ?? rowData?.fabrCodigo} -{' '}
                                {rowData?.descricaoFabrSge}
                              </div>
                            )}
                          />
                          <Column
                            label=""
                            dataKey="acoes"
                            width={140}
                            flexShrink={0}
                            cellRenderer={({ rowData }) => (
                              <div className="float-right">
                                <Tooltip title="Visualizar Logs">
                                  <Button
                                    size="sm"
                                    color="default"
                                    outline
                                    onClick={() => mostrarModalLog(rowData)}
                                  >
                                    <FaHistory />
                                  </Button>
                                </Tooltip>

                                <Button
                                  size="sm"
                                  className="btn-icon"
                                  color="info"
                                  title="Visualizar dados de Precificação"
                                  onClick={() =>
                                    mostrarLogPrecificacao(rowData)
                                  }
                                >
                                  <FaMoneyBill />
                                </Button>

                                <Button
                                  size="sm"
                                  className="btn-icon"
                                  color="info"
                                  title="Visualizar dados de Composição"
                                  onClick={() => mostrarLogComposicao(rowData)}
                                >
                                  <FaRegListAlt />
                                </Button>
                              </div>
                            )}
                          />
                        </Tbl>
                      )}
                    </AutoSizer>
                  </div>
                </div>
              )}
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Materiais;
